<script>
/** 本地配置测试服 （宠赞）**/
//const domain='http://api.laoban.com/';
//const epdomain='http://api.laoban.com/';
//const uploadUrl='https://third.chonglaoban.com.cn/fileOperate/agentImageUpload';
//const exportUrl='http://api.laoban.com/';
//const uploadavarge='http://static.chonglaoban.cn/clb/avarge';
//const staticUrl= '' //'https://static.chonglaoban.cn';
//const editorimageUrl='http://static.chonglaoban.cn/upload/editor-images';
//const tmallreturnurl='http://testczapi.chonglaoban.com.cn/TmallBCk/index';

/** a20 正式服务器配置（宠赞新版） **/
const domain='https://dealer20.chonglaoban.cn/';
const epdomain='https://dealer20.renrenchong.cn/';
// const uploadUrl='https://static.chonglaoban.cn/clb/agentindex';
const uploadUrl='https://third.chonglaoban.cn/fileOperate/agentImageUpload';
const uploadavarge='https://static.chonglaoban.cn/clb/avarge';
const exportUrl='https://dealer20.chonglaoban.cn/';
const staticUrl= ''//'https://static.chonglaoban.cn';
const editorimageUrl='https://static.chonglaoban.cn/upload/editor-images';
const tmallreturnurl='';


/** 预发布测试服务器配置（宠赞预发布版） **/
// const domain='http://testczapi.chonglaoban.cn/';
// const epdomain='http://testczapi.chonglaoban.cn/';
// const uploadUrl='https://third.chonglaoban.cn/fileOperate/agentImageUpload';
// const uploadavarge='http://static.chonglaoban.cn/clb/avarge';
// const exportUrl='http://testczapi.chonglaoban.cn/';
// const staticUrl=''//'http://static.chonglaoban.cn';
// const editorimageUrl='http://static.chonglaoban.cn/upload/editor-images';
// const tmallreturnurl='';


/**110 **/
// const domain='http://czapi110.chonglaoban.cn/';
// const epdomain='http://czapi110.chonglaoban.cn/';
// const uploadUrl='https://third.chonglaoban.cn/fileOperate/agentImageUpload';
// const uploadavarge='http://static.chonglaoban.cn/clb/avarge';
// const exportUrl='http://czapi110.chonglaoban.cn/';
// const staticUrl='http://static.chonglaoban.cn';
// const editorimageUrl='http://static.chonglaoban.cn/upload/editor-images';
// const tmallreturnurl='';

/** 测试服务器配置（宠赞） **/
// const domain='http://testczapi.chonglaoban.com.cn/';
// const epdomain='http://testczapi.chonglaoban.com.cn/';
// const uploadUrl='https://third.chonglaoban.com.cn/fileOperate/agentImageUpload';
// const exportUrl='http://testczapi.chonglaoban.com.cn/';
// const uploadavarge='http://static.chonglaoban.cn/clb/avarge';
// const staticUrl=''//'http://static.chonglaoban.cn';
// const editorimageUrl='http://static.chonglaoban.cn/upload/editor-images';
// const tmallreturnurl='http://testczapi.chonglaoban.com.cn/TmallBCk/index';

const errortext='异常错误，请联系软件提供商！';

export default
{
	domain,
	uploadUrl,
	uploadavarge,
	staticUrl,
	editorimageUrl,
	exportUrl,
	tmallreturnurl,
	errortext
}
</script>



// WEBPACK FOOTER //
// src/components/Global.vue